import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query Calendars($page: Int, $perPage: Int, $search: String) {
    Calendars(page: $page, perPage: $perPage, search: $search) {
      items {
        id
        title
        unitName
        startDate
        endDate
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  title: string;
  endDate: Date;
  startDate: Date;
  unitName: string;
}

export interface GetAllGql {
  Calendars: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
